import React from 'react';


interface Props {
  direction: number,
  type: string,
  handler: (direction: number, type: string) => void
}

interface ItemProps {
  className: string,
  content: string,
  direction: number,
  nativeType: string,
  type: string,
  handler: (direction: number, type: string) => void
}


const getArrow = (dir: number) => (dir === -1
    ? <span className={'m-r-5'}>&uarr;</span>
    : <span className={'m-r-5'}>&darr;</span>
);

const ItemComponent: React.FC<ItemProps> = ({className, content, direction, nativeType, type, handler}) => {
  const onClick = () => {
    nativeType === type
      ? handler(direction * (-1), type)
      : handler(direction, nativeType)
  };

  return (
    <div className={'alerts-table-title__item ' + className}
         onClick={onClick}
    >
      {nativeType === type ? getArrow(direction) : null}
      {content}
    </div>
  )
};

const AlertsTableTitleComponent: React.FC<Props> = ({type, direction, handler}) => {

  return (
    <div className='alerts-table__title'>
      <ItemComponent className={'priority'}
                     content={'Priority'}
                     direction={direction}
                     nativeType={'prio'}
                     type={type}
                     handler={handler}
      />
      <ItemComponent className={'time'}
                     content={'Time'}
                     direction={direction}
                     nativeType={'when'}
                     type={type}
                     handler={handler}
      />
      <ItemComponent className={'rule'}
                     content={'Rule'}
                     direction={direction}
                     nativeType={'what'}
                     type={type}
                     handler={handler}
      />
      <ItemComponent className={'camera'}
                     content={'Camera'}
                     direction={direction}
                     nativeType={'where'}
                     type={type}
                     handler={handler}
      />
    </div>
  );
};

export default AlertsTableTitleComponent;